export default class Accordeon {

	constructor() {
		this.addEvents();
	}

	addEvents() {
		$( document ).ready(function() {
			$('.accordeon__item--title').on('click', function (e){
				e.preventDefault();
				let parent = $(this).parents('.accordeon__item');
				parent.hasClass('active') ? parent.removeClass('active') : parent.addClass('active');
			})
		})
	}

}